module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(node.index==='') { ;
__p += '\n	<span class="' +
((__t = (rootClassName)) == null ? '' : __t) +
'"></span>&nbsp;<span class="DescartesUIText" title="' +
((__t = (rootTitle)) == null ? '' : __t) +
'">' +
((__t = (rootTitle)) == null ? '' : __t) +
'</span>\n';
 } ;
__p += '\n\n';
 if(node.CLASS_NAME.indexOf('Descartes.Layer') === 0) { ;
__p += '\n\n	';
 if(displayIconLoading && node.loading === true) { ;
__p += '\n		<span class="loader"></span>\n	';
 } else if(_.isString(node.loading)){ ;
__p += '\n		';
 if(fctVisibility) { ;
__p += '\n			<span class="Descartes-visible-stack" title="' +
((__t = (visibleTitle)) == null ? '' : __t) +
'">\n				<span class="' +
((__t = (visibleClassName)) == null ? '' : __t) +
'"></span>\n				<span class="' +
((__t = (needZoomClassName)) == null ? '' : __t) +
'"></span>\n		    </span>\n		';
  } ;
__p += '\n		<span class="text-danger" title="' +
((__t = (node.loading)) == null ? '' : __t) +
'">\n	   		 <i class="' +
((__t = (loadErrorClassName)) == null ? '' : __t) +
'" aria-hidden="true"></i>\n		</span>\n\n	';
 } else {
			if(fctVisibility) {
			;
__p += '\n				<span class="Descartes-visible-stack" title="' +
((__t = (visibleTitle)) == null ? '' : __t) +
'">\n				    <span class="' +
((__t = (visibleClassName)) == null ? '' : __t) +
'"></span>\n				    <span class="' +
((__t = (needZoomClassName)) == null ? '' : __t) +
'"></span>\n				</span>\n			';
  }
		    if((!displayMoreInfos || !displayMoreInfosParams.fctQueryable) && fctQueryable) { ;
__p += '\n				<span class="' +
((__t = (queryableClassName)) == null ? '' : __t) +
'" title="' +
((__t = (queryableTitle)) == null ? '' : __t) +
'"></span>\n				';
 if(node.sheetable) {;
__p += '\n					<span class="' +
((__t = (sheetableClassName)) == null ? '' : __t) +
'" title="' +
((__t = (sheetableTitle)) == null ? '' : __t) +
'"></span>\n				';
};
__p += '\n			';
};
__p += '\n\n			<span class="indent-2"></span>\n			';
 if((!displayMoreInfos || !displayMoreInfosParams.fctOpacity) && fctOpacity) { ;
__p += '\n				<span class="indent-2"></span>\n				<span id="' +
((__t = (id)) == null ? '' : __t) +
'_SliderA"></span>\n				<span class="indent-2"></span>\n			';
 } ;
__p += '\n	';
 } ;
__p += '\n	\n	';
 if(displayMoreInfosParams.displayOnClickLayerName && node.isVisible() && ((displayMoreInfosParams.fctQueryable && fctQueryable && node.queryable) || (displayMoreInfosParams.fctOpacity && fctOpacity) || (displayMoreInfosParams.fctMetadataLink) || (displayMoreInfosParams.fctDisplayLegend && fctDisplayLegend && node.legend))) { ;
__p += '\n	<a href="#d-' +
((__t = (node.id)) == null ? '' : __t) +
'" class="DescartesLayersTreeHref" data-toggle="collapse"><span title="' +
((__t = (node.title)) == null ? '' : __t) +
'" class="' +
((__t = (itemTextClassName)) == null ? '' : __t) +
'">' +
((__t = (node.title)) == null ? '' : __t) +
'</span></a>\n	';
 } else { ;
__p += '\n	<span title="' +
((__t = (node.title)) == null ? '' : __t) +
'" class="' +
((__t = (itemTextClassName)) == null ? '' : __t) +
'">' +
((__t = (node.title)) == null ? '' : __t) +
'</span>\n	';
 } ;
__p += '\n	\n	';
 if(!displayMoreInfos || !displayMoreInfosParams.fctMetadataLink) { ;
__p += '\n	';
if(!_.isEmpty(metadataHref)) {;
__p += '\n		<a href="' +
((__t = (metadataHref)) == null ? '' : __t) +
'" class="' +
((__t = (metadataClassName)) == null ? '' : __t) +
'" title="' +
((__t = (metadataTitle)) == null ? '' : __t) +
'" target="_blank"></a>\n	';
 } else if(fctMetadataLink) {;
__p += '\n		<span class="' +
((__t = (noMetadataClassName)) == null ? '' : __t) +
'" title="' +
((__t = (noMetadataTitle)) == null ? '' : __t) +
'"></span>\n	';
 } ;
__p += '\n	';
 } ;
__p += '\n\n	';
 if(displayMoreInfos && node.isVisible() && ((displayMoreInfosParams.fctQueryable && fctQueryable && node.queryable) || (displayMoreInfosParams.fctOpacity && fctOpacity) || (displayMoreInfosParams.fctMetadataLink) || (displayMoreInfosParams.fctDisplayLegend && fctDisplayLegend))) {  ;
__p += '\n		';
 if(!displayMoreInfosParams.displayOnClickLayerName && displayMoreInfosParams.fctDisplayLegend && fctDisplayLegend && !(displayMoreInfosParams.fctOpacity && fctOpacity) && !(displayMoreInfosParams.fctQueryable && fctQueryable) && !(displayMoreInfosParams.fctMetadataLink)){ ;
__p += '\n		';
 if(node.legend){ ;
__p += '\n		<a href="#d-' +
((__t = (node.id)) == null ? '' : __t) +
'" class="DescartesLayersTreeMoreInfos ' +
((__t = (displayMoreInfoLegendClassName)) == null ? '' : __t) +
'" data-toggle="collapse" title="' +
((__t = (displayMoreInfoLegendTitle)) == null ? '' : __t) +
'"></a>\n		';
 } ;
__p += '\n		';
 } else if (!displayMoreInfosParams.displayOnClickLayerName) {;
__p += '\n		<a href="#d-' +
((__t = (node.id)) == null ? '' : __t) +
'" class="DescartesLayersTreeMoreInfos ' +
((__t = (displayMoreInfosClassName)) == null ? '' : __t) +
'" data-toggle="collapse" title="' +
((__t = (displayMoreInfosTitle)) == null ? '' : __t) +
'"></a>\n		';
 } ;
__p += '\n		<div id="d-' +
((__t = (node.id)) == null ? '' : __t) +
'" class="collapse">	\n\n			';
 if(displayMoreInfosParams.fctQueryable && fctQueryable) { ;
__p += '\n				<span class="' +
((__t = (queryableClassName)) == null ? '' : __t) +
'" title="' +
((__t = (queryableTitle)) == null ? '' : __t) +
'"></span>\n				';
 if(node.sheetable) {;
__p += '\n					<span class="' +
((__t = (sheetableClassName)) == null ? '' : __t) +
'" title="' +
((__t = (sheetableTitle)) == null ? '' : __t) +
'"></span>\n				';
};
__p += '\n			';
};
__p += '\n			\n			';
 if(displayMoreInfosParams.fctOpacity && fctOpacity) { ;
__p += '\n				<span class="indent-2"></span>\n				<span id="' +
((__t = (id)) == null ? '' : __t) +
'_SliderA"></span>\n				<span class="indent-2"></span>\n			';
 } ;
__p += '\n			\n			';
 if(displayMoreInfosParams.fctMetadataLink) { ;
__p += '\n				';
if(!_.isEmpty(metadataHref)) {;
__p += '\n					<a href="' +
((__t = (metadataHref)) == null ? '' : __t) +
'" class="' +
((__t = (metadataClassName)) == null ? '' : __t) +
'" title="' +
((__t = (metadataTitle)) == null ? '' : __t) +
'" target="_blank"></a>\n				';
 } else if(fctMetadataLink) {;
__p += '\n					<span class="' +
((__t = (noMetadataClassName)) == null ? '' : __t) +
'" title="' +
((__t = (noMetadataTitle)) == null ? '' : __t) +
'"></span>\n				';
 } ;
__p += '\n			';
 } ;
__p += '\n				\n		 	';
 if(displayMoreInfosParams.fctDisplayLegend && fctDisplayLegend) { ;
__p += '\n\n					';
_.each(node.legend,function(legend) {;
__p += '\n						<div>\n							<img id="legend-d-' +
((__t = (node.id)) == null ? '' : __t) +
'" async-src="' +
((__t = (legend)) == null ? '' : __t) +
'" class="DescartesLayersTreeLegendImage legend-d-' +
((__t = (node.id)) == null ? '' : __t) +
'"/>\n						</div>\n					';
});;
__p += '\n\n			';
 } ;
__p += '	\n		</div>\n	\n	';
 } ;
__p += '\n	\n	';
 if((!displayMoreInfos || !displayMoreInfosParams.fctDisplayLegend) && fctDisplayLegend && node.isVisible()) {  ;
__p += '\n\n		';
_.each(node.legend,function(legend) {;
__p += '\n			<div>\n				<img src="' +
((__t = (legend)) == null ? '' : __t) +
'" class="DescartesLayersTreeLegendImage"/>\n			</div>\n		';
});;
__p += '\n	';
 } ;
__p += '\n	\n\n	\n';
 } else if(node.CLASS_NAME.indexOf('Descartes.Group') === 0 && node.index!=='') {;
__p += '\n	<span title="' +
((__t = (node.title)) == null ? '' : __t) +
'" class="' +
((__t = (itemTextClassName)) == null ? '' : __t) +
'">' +
((__t = (node.title)) == null ? '' : __t) +
'</span>\n';
 } ;


}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/TreeItem.ejs
// module id = 395
// module chunks = 0